import Button from "components/Button";
import Grid from "components/Grid";
import Loader from "components/Loader";
import SingleSelect from "components/SingleSelect";
import Text from "components/Text";
import TextInput from "components/TextInput";
import PageContent from "pages/PageContent";
import {
    ProfileContentWrapper,
    StraightLine,
    SubHeading,
} from "pages/PageContent/PageContent.styled";
import { FC, useEffect } from "react";
import { BsArrowRight } from "react-icons/bs";
import theme from "theme";
import { useContactInfo } from "./useContactInfo";

export const ContactInfo: FC = () => {
    const {
        inputs,
        inputErrors,
        handleInputChange,
        handleSubmit,
        navigateToNextPage,
        isLoading,
        countries,
        isFetchingData,
        handleSelectChange,
    } = useContactInfo();
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, []);
    return (
        <PageContent>
            <ProfileContentWrapper>
                {isFetchingData && <Loader size={28} />}
                <Text
                    variant="heading5"
                    fontWeight="700"
                    color={theme.colors.grey.dark}
                >
                    Complete Your Profile (2/3)
                </Text>
                <SubHeading variant="label">
                    Company Information <StraightLine />
                </SubHeading>
                <Grid
                    row={true}
                    expanded
                    marginTop={2}
                    columnGap={1}
                    rowGap={1}
                >
                    <TextInput
                        name="firstName"
                        label="First Name"
                        required
                        placeholder="Enter first name"
                        labelColor={theme.colors.text}
                        value={inputs.firstName}
                        errorMsg={inputErrors.firstName}
                        onChange={handleInputChange}
                        minWidth="250px"
                    />
                    <TextInput
                        name="lastName"
                        label="Last Name"
                        required
                        placeholder="Enter last name"
                        labelColor={theme.colors.text}
                        value={inputs.lastName}
                        errorMsg={inputErrors.lastName}
                        onChange={handleInputChange}
                        minWidth="250px"
                    />
                </Grid>
                <Grid
                    row={true}
                    expanded
                    marginTop={2}
                    columnGap={1}
                    rowGap={1}
                >
                    <TextInput
                        name="phone"
                        label="Phone"
                        required
                        placeholder="Enter phone"
                        labelColor={theme.colors.text}
                        minWidth="250px"
                        value={inputs.phone}
                        errorMsg={inputErrors.phone}
                        onChange={handleInputChange}
                    />
                </Grid>
                <Grid row={true} expanded marginTop={1}>
                    <TextInput
                        name="email"
                        label="Email"
                        required
                        readOnly
                        placeholder="Enter email"
                        labelColor={theme.colors.text}
                        minWidth="510px"
                        value={inputs.email}
                        errorMsg={inputErrors.email}
                        onChange={handleInputChange}
                    />
                </Grid>
                <Grid row={true} expanded marginTop={1}>
                    <TextInput
                        name="address"
                        label="Address"
                        required
                        placeholder="Enter address"
                        labelColor={theme.colors.text}
                        minWidth="510px"
                        value={inputs.address}
                        errorMsg={inputErrors.address}
                        onChange={handleInputChange}
                    />
                </Grid>
                <Grid
                    row={true}
                    expanded
                    marginTop={2}
                    columnGap={1}
                    rowGap={1}
                >
                    <TextInput
                        name="city"
                        label="City"
                        required
                        placeholder="Enter city"
                        labelColor={theme.colors.text}
                        minWidth="250px"
                        value={inputs.city}
                        errorMsg={inputErrors.city}
                        onChange={handleInputChange}
                    />
                    <TextInput
                        name="state"
                        label="State"
                        required
                        placeholder="Enter state"
                        labelColor={theme.colors.text}
                        minWidth="250px"
                        value={inputs.state}
                        errorMsg={inputErrors.state}
                        onChange={handleInputChange}
                    />
                </Grid>
                <Grid
                    row={true}
                    expanded
                    marginTop={2}
                    columnGap={1}
                    rowGap={1}
                >
                    <SingleSelect
                        label="Country"
                        required
                        minWidth="250px"
                        name="country"
                        searchable
                        errorText={inputErrors.country}
                        options={countries}
                        value={inputs.country}
                        onChange={(value) =>
                            handleSelectChange("country", value)
                        }
                    />
                    <TextInput
                        name="zip"
                        label="Zip"
                        required
                        placeholder="Enter zip"
                        labelColor={theme.colors.text}
                        minWidth="250px"
                        value={inputs.zip}
                        errorMsg={inputErrors.zip}
                        onChange={handleInputChange}
                    />
                </Grid>
                <Grid
                    row={true}
                    columnGap={1}
                    marginTop={3}
                    marginBottom={1}
                    rowGap={1}
                >
                    <Button
                        variant="outlined"
                        isLoading={!navigateToNextPage && isLoading}
                        onClick={() => handleSubmit(false)}
                    >
                        Save
                    </Button>
                    <Button
                        icon={<BsArrowRight />}
                        isLoading={navigateToNextPage && isLoading}
                        onClick={() => handleSubmit(true)}
                    >
                        Save & Next
                    </Button>
                </Grid>
            </ProfileContentWrapper>
        </PageContent>
    );
};
